// extracted by mini-css-extract-plugin
module.exports = {"cardsList":"ArticleUserViewCards_cardsList__1gb2h"};